/*
 Copyright 2019-present wobe-systems GmbH

 Licensed under the Apache License, Version 2.0 (the 'License');
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an 'AS IS' BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
*/
import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import { flow } from '@/store/flow/index';
import { api } from '@/store/apis/index';
import { pkg } from '@/store/packages/index';
import { brick } from '@/store/bricks/index';
import { user } from '@/store/user/index';
import { types } from '@/store/typeLibrary/index';
import { error } from '@/store/errors/index';
import { workspace } from '@/store/workspace/index';
import { platformConfig } from '@/store/platformConfig/index';
import { invitation } from '@/store/inviteUser/index';
import { RootState } from './models';

Vue.use(Vuex);

const store: StoreOptions<RootState> = {
  state: {
    version: '0.1.0',
  },
  modules: {
    flow,
    brick,
    user,
    error,
    platformConfig,
    invitation,
    pkg,
    workspace,
    api,
    types,
  },
};

export default new Vuex.Store<RootState>(store);
